<template>
	<div class="lightbox">
		<button type="button" class="lightbox-close" @click=closeModal>
			<i class="fas fa-times"></i>
		</button>
		<div class="lightbox-content">
			<div class="p-2">
				This feature will not be available until showtime.<br/>We know you are excited, but please wait for us to announce when it is ready.
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			closeModal() {
				this.$emit("close")
			}
		}
	}
</script>

<style scoped>
.p-2 {
	padding: 2em;
}
</style>
